import React from "react";
import { C } from "../constants/baziData";

const SEASONS = {
  spring: { emoji: "🌸", label: "春季", labelEn: "Spring", element: "木", months: "2–4月", monthsEn: "Feb–Apr" },
  summer: { emoji: "☀️", label: "夏季", labelEn: "Summer", element: "火", months: "5–7月", monthsEn: "May–Jul" },
  autumn: { emoji: "🍂", label: "秋季", labelEn: "Autumn", element: "金", months: "8–10月", monthsEn: "Aug–Oct" },
  winter: { emoji: "❄️", label: "冬季", labelEn: "Winter", element: "水", months: "11–1月", monthsEn: "Nov–Jan" },
};

const ELEM_GENERATE = { "木": "火", "火": "土", "土": "金", "金": "水", "水": "木" };
const ELEM_CONTROL  = { "木": "土", "火": "金", "土": "水", "金": "木", "水": "火" };

const PERIOD_COLORS = {
  "补能期": { bg: "#D1FAE5", border: "#34D399", text: "#065F46", label: "补能期" },
  "平稳期": { bg: "rgba(212,175,55,.10)", border: "rgba(212,175,55,.45)", text: "#78450A", label: "平稳期" },
  "警惕期": { bg: "#FEE2E2", border: "#FCA5A5", text: "#991B1B", label: "警惕期" },
};

function classifySeason(seasonElem, yong, xi, ji, chou) {
  if (seasonElem === yong || seasonElem === xi) return "补能期";
  if (seasonElem === ji || seasonElem === chou) return "警惕期";
  // Generated element of yong also helps
  if (ELEM_GENERATE[seasonElem] === yong) return "补能期";
  return "平稳期";
}

function SeasonCard({ season, key: _key, period, lang }) {
  const col = PERIOD_COLORS[period] || PERIOD_COLORS["平稳期"];
  const label = lang === "zh" ? season.label : season.labelEn;
  const months = lang === "zh" ? season.months : season.monthsEn;

  return (
    <div style={{
      background: col.bg,
      border: `1px solid ${col.border}`,
      borderRadius: 10,
      padding: "18px 16px",
      display: "flex",
      flexDirection: "column",
      gap: 8,
    }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
        <div>
          <span style={{ fontSize: 22 }}>{season.emoji}</span>
          <span style={{
            marginLeft: 8, fontSize: 16, fontWeight: 700,
            color: col.text,
          }}>{label}</span>
        </div>
        <span style={{
          fontSize: 10, fontFamily: "sans-serif",
          padding: "2px 10px", borderRadius: 12,
          background: col.border + "30",
          color: col.text, fontWeight: 700,
          border: `1px solid ${col.border}`,
        }}>{period}</span>
      </div>
      <div style={{
        fontSize: 11, color: col.text, opacity: .8,
        fontFamily: "sans-serif",
      }}>
        {lang === "zh" ? `五行：${season.element}` : `Element: ${season.element}`}
        &nbsp;·&nbsp;{months}
      </div>
      <div style={{
        fontSize: 12, color: col.text, lineHeight: 1.7,
      }}>
        {period === "补能期"
          ? (lang === "zh" ? `${season.element}旺之季，顺势补充${season.element}元素能量，利于启动与扩展。` : `${season.element} is strong. Favorable for new starts and expansion.`)
          : period === "警惕期"
          ? (lang === "zh" ? `${season.element}旺势对你的用神形成压制，宜低调蓄力，避免重大决策。` : `${season.element} dominates, suppressing your favorable element. Stay low and conserve energy.`)
          : (lang === "zh" ? `能量中性，保持节律，维持现有方向即可。` : `Neutral energy. Maintain rhythm and current direction.`)}
      </div>
    </div>
  );
}

function YearlyProtocol({ xiyongshen, strength, current_period, lang }) {
  if (!xiyongshen) return null;

  const xy = xiyongshen || {};
  const yong = xy.yong?.element || xy.yong_shen || "";
  const xi   = xy.xi?.element   || xy.xi_shen   || "";
  const ji   = xy.ji?.element   || xy.ji_shen   || "";
  const chou = xy.chou?.element || xy.chou_shen || "";

  const seasonKeys = ["spring", "summer", "autumn", "winter"];

  return (
    <div>
      <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: 12,
        marginBottom: 20,
      }}>
        {seasonKeys.map(k => {
          const s = SEASONS[k];
          const period = classifySeason(s.element, yong, xi, ji, chou);
          return (
            <SeasonCard key={k} season={s} period={period} lang={lang} />
          );
        })}
      </div>

      {/* Monthly rhythm summary */}
      <div style={{
        background: "rgba(212,175,55,.05)",
        border: "1px solid rgba(212,175,55,.20)",
        borderRadius: 10,
        padding: "18px 20px",
      }}>
        <div style={{
          fontFamily: "sans-serif", fontSize: 11, fontWeight: 700,
          color: "#A0813C", letterSpacing: ".1em", textTransform: "uppercase",
          marginBottom: 12,
        }}>
          {lang === "zh" ? "年度修持节律" : "Yearly Practice Rhythm"}
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          {[
            {
              key: lang === "zh" ? "每月初" : "Month start",
              text: lang === "zh" ? "花 10 分钟对照喜用神方向，评估上月「补给与消耗」平衡。" : "10 min review of favorable-element balance vs. last month.",
            },
            {
              key: lang === "zh" ? "补能期" : "Favorable seasons",
              text: lang === "zh" ? `着力启动重要项目、深化关系，感受${yong||"用神"}元素的流动。` : `Launch key projects and deepen relationships. Embrace ${yong||"favorable"}-element activities.`,
            },
            {
              key: lang === "zh" ? "警惕期" : "Cautious seasons",
              text: lang === "zh" ? "避免重大决策与高风险行动，以静制动，蓄养能量。" : "Avoid major decisions. Rest, reflect, and conserve energy.",
            },
            {
              key: lang === "zh" ? "每季末" : "Season end",
              text: lang === "zh" ? "做一次能量回顾：哪些行动带来了「补能感」，哪些造成了「漏气」？" : "Energy review: what charged you vs. drained you this season?",
            },
          ].map((item, i) => (
            <div key={i} style={{
              display: "flex", gap: 10, paddingBottom: 8,
              borderBottom: i < 3 ? "1px solid rgba(212,175,55,.12)" : "none",
            }}>
              <span style={{
                fontFamily: "sans-serif", fontSize: 10,
                color: "#846B32", fontWeight: 700,
                minWidth: 52, paddingTop: 2,
              }}>{item.key}</span>
              <span style={{ fontSize: 12, color: "#4A3A2A", lineHeight: 1.75 }}>{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default YearlyProtocol;
